export default __webpack_public_path__ + "static/media/589.a3bc8115.png";